import { useSelector } from 'react-redux';
import { RootState } from '@/lib/store';
import useTranslation from 'next-translate/useTranslation';
import { useToggle } from '@starsoft/common/hooks';
import { AnimatePresence } from 'framer-motion';
import OrderByProvidersProvidersCard from './ProvidersCard';
import styles from './styles.module.scss';

export default function OrderByProvidersButton() {
  const { t } = useTranslation('common');
  const [isOpen, toggle] = useToggle();
  const providers: bigint[] = useSelector(
    (state: RootState) => state.casino.providersList,
  );

  return (
    <div className={styles.container}>
      <button
        className={styles.container__button}
        disabled={isOpen}
        onClick={toggle}
      >
        <span>
          {t('tab_providers')} {providers.length > 0 && `(${providers.length})`}
        </span>

        <i className="fa-solid fa-chevron-down" />
      </button>

      <AnimatePresence>
        {isOpen && <OrderByProvidersProvidersCard handleClose={toggle} />}
      </AnimatePresence>
    </div>
  );
}
